<template>
  <el-table
    :data="tableData"
    style="width: 100%"
    height="250px"
    highlight-current-row
    @current-change="handleCurrentChange"
    class="delivery-points">
    <el-table-column fixed label="#" type="index" align="center" width="50">
    </el-table-column>
    <el-table-column prop="suborders" label="CANT." align="center" width="95">
      <template slot-scope="scope">
        <span v-if="scope.row.name">-</span>
        <span v-else class="driverTable">
          <el-badge :value="scope.row.suborders.length" class="item">
          </el-badge>
        </span>
      </template>
    </el-table-column>
    <el-table-column
      minWidth="200"
      prop="point.street.name"
      label="DIRECCIÓN"
      align="center">
      <template slot-scope="scope">
        {{setAddress(scope.row)}}
      </template>
    </el-table-column>
    <el-table-column prop="estimate_at" label="VENTANA" align="center" min-width="130">
      <template slot-scope="scope">
        {{getTimeWindow(scope.row)}}
      </template>
    </el-table-column>
    <el-table-column prop="estimate_at" label="ESTIMADO" align="center" min-width="180">
      <template slot-scope="scope">
        {{setDateToTime({
        date: scope.row,
        type: 'estimated'
        })
        }}
      </template>
    </el-table-column>
    <el-table-column prop="arrival_at" label="REAL" align="center" min-width="180">
      <template slot-scope="scope">
        {{setDateToTime({
        date: scope.row,
        type: 'real'
        })
        }}
      </template>
    </el-table-column>
    <el-table-column label="ESTADO" align="center" width="100">
      <template slot-scope="scope">
        <el-tag size="mini"
                v-if="!scope.row.name && checkState(scope) === 'DIGITADO'"
                :hit="true"
                style="background-color: #00b0ff; color: #333333;  opacity: 0.8;">
          {{checkState(scope)}}
        </el-tag>
        <el-tag size="mini"
                v-if="!scope.row.name && checkState(scope) === 'TERMINADO'"
                :hit="true"
                :type="'sucess'">
          {{checkState(scope)}}
        </el-tag>
        <el-tag size="mini"
                v-if="!scope.row.name && checkState(scope) === 'PENDIENTE'"
                :hit="true"
                :type="'warning'">
          {{checkState(scope)}}
        </el-tag>
        <el-tag size="mini"
                v-if="!scope.row.name && checkState(scope) === 'CANCELADO'"
                :hit="true"
                :type="'danger'">
          {{checkState(scope)}}
        </el-tag>
        <el-tag size="mini"
                v-if="!scope.row.name && checkState(scope) === 'EN RUTA'"
                :hit="true"
                :type="'info'">
          {{checkState(scope)}}
        </el-tag>
        <div v-if="scope.row.name">
          ---
        </div>
      </template>
    </el-table-column>
    <el-table-column label="DETALLE" align="center" width="80" type="expand">
      <template slot-scope="scope">
        <div v-if="scope.row.name" class="ctTableTitleStyle">
          CENTRO DE DISTRIBUCIÓN
        </div>
        <div v-else>
          <el-table :data="scope.row.suborders">
            <el-table-column
              type="index"
              align="center"
              label="-">
              <template>
                <i class="dotStyle fa fa-circle" aria-hidden="true"></i>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="SUB ORDEN"
              prop="code"/>
            <el-table-column
              align="center"
              label="F12"
              prop="do"/>
            <el-table-column
              v-if="suborderDetail"
              align="center"
              width="100"
              label="DETALLE"
              prop="do">
              <template slot-scope="scope">
                <el-button
                  class="linkStyle"
                  v-if="!scope.row.name"
                  @click="handleSeeMore(scope.row.code)">Ver Más</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-button
          class="linkStyle"
          v-if="!scope.row.name"
          @click="handleSeeMore(scope.$index, scope.row)">Ver Más</el-button> -->
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import moment from 'moment';
import { decodeRSA } from '../../mixins/function';

export default {
  props: {
    tableData: {
      required: true,
    },
    suborderDetail: {
      type: Boolean,
      default: true,
    },
  },
  filters: {
    applyDecodeRSA(data) {
      return decodeRSA(data);
    },
  },
  data() {
    return {
    };
  },
  methods: {
    handleCurrentChange(data) {
      this.$emit('infoWindowPoint', data.route_position);
    },
    close() {
      this.$emit('restart', 0);
    },
    initialLoad() {
      // información del mapa
      this.routes = [this.dataDriver];
      this.routesOrdenadas = this.routes[0].delivery_points;
      this.routesOrdenadas.sort((a, b) => {
        let result;
        if (a.route_position > b.route_position) {
          result = 1;
        } else if (b.route_position > a.route_position) {
          result = -1;
        } else {
          result = 0;
        }
        return result;
      });
      this.charge = true;
      // informacion del chofer
      this.informacionChofer.nombre = `${this.dataDriver.driver.first_name} ${this.dataDriver.driver.last_name}`;
      this.informacionChofer.telefono = this.dataDriver.driver.phone;
      this.informacionChofer.patente = this.dataDriver.vehicle.patent;
    },
    abrirInfo() {
      // información del mapa
      this.routesTable = [this.dataDriver];
      this.routesOrdenadas = this.routesTable[0].delivery_points;
      this.routesOrdenadas.sort((a, b) => {
        let result;
        if (a.route_position > b.route_position) {
          result = 1;
        } else if (b.route_position > a.route_position) {
          result = -1;
        } else {
          result = 0;
        }
        return result;
      });
      this.routesOrdenadas.unshift(this.dataDriver.distribution_center);
      this.routesOrdenadas.push(this.dataDriver.distribution_center);
      // informacion del chofer
      this.informacionChofer.nombre = `${this.dataDriver.driver.first_name} ${this.dataDriver.driver.last_name}`;
      this.informacionChofer.telefono = this.dataDriver.driver.phone;
      this.informacionChofer.patente = this.dataDriver.vehicle.patent;
    },
    setAddress(row) {
      if (decodeRSA(row.point.street.name) === '') {
        return `${decodeRSA(row.raw_address)}, ${row.point.street.commune.name}`;
      }
      return `${decodeRSA(row.point.street.name)} ${row.point.street_number}, ${row.point.street.commune.name}`;
    },
    setDO(row) {
      if (row.row.name) {
        return row.row.name;
      }
      return row.row.suborders[0].do;
    },
    getTimeWindow(row) {
      if (row.time_windows !== null) {
        if (row.time_windows.length > 0) {
          let minTime = new Date(row.time_windows[0].time_init);
          let maxTime = new Date(row.time_windows[0].time_finish);
          row.time_windows.forEach((tm) => {
            const auxInit = new Date(tm.time_init);
            const auxFinish = new Date(tm.time_finish);
            if (auxInit < minTime) {
              minTime = auxInit;
            }
            if (auxFinish > maxTime) {
              maxTime = auxFinish;
            }
          });
          return `${moment.utc(minTime).format('HH:mm')} - ${moment.utc(maxTime).format('HH:mm')}`;
        }
      }
      return '-';
    },
    checkState(row) {
      if (row.row.suborders) {
        // eslint-disable-next-line no-unused-vars
        let stateNumber = null;
        row.row.suborders.forEach((suborder) => {
          suborder.packages.forEach((p) => {
            const l = JSON.parse(JSON.stringify(p.states)).sort(
              (a, b) => (a.created_at > b.created_at ? -1 : 1),
            );

            stateNumber = l[0].state_types_id;
          });
        });
        Math.max.apply(null, row.row.suborders.packages);
        if (stateNumber === 1) { return 'DIGITADO'; }
        if (stateNumber === 5) { return 'TERMINADO'; }
        if (stateNumber === 4) { return 'PENDIENTE'; }
        if (stateNumber === 6) { return 'CANCELADO'; }
        if (stateNumber === 3) { return 'EN RUTA'; }
      }
      return '---';
    },
    setDateToTime({ date, type }) {
      if (type === 'real') {
        if ('suborders' in date) {
          const info = date.arrival_at;
          if (info !== '0001-01-01T00:00:00Z') {
            const aux = new Date(info);
            return moment(aux).format('DD-MM-YYYY HH:mm:ss');
          }
        }
      } else {
        if ('estimated_at' in date) {
          const aux = new Date(date.estimated_at);
          if (aux.getFullYear() > 2000) {
            return moment(aux).format('DD-MM-YYYY HH:mm:ss');
          }
        }
        return '---';
      }
      return '---';
    },
    handleSeeMore(el) {
      this.$emit('clickOnClient', el);
    },
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  watch: {
  },
};
</script>

<style scoped>
  .container {
    box-sizing: border-box;
    overflow: hidden;
  }
  .topTitle {
    text-transform: uppercase;
    font-size: 16px;
    text-align: left;
    margin: 0 0 5px;
  }
  .value-style {
    font-weight: 300;
    font-size: 18px;
  }
  .key-style {
    font-weight: 700;
    font-size: 10px;
    color: #AAD500;
    margin-bottom: 1em;
  }
  .box-info-style {
    text-align: left;
  }
  th, td {
    padding: 0px !important;
    text-align: left;
  }
  .home-boton i {
    font-size: 50px;
    color: #AAD500;
    margin-top: 5%;
    cursor: pointer;
  }
  .linkStyle{
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 15px;
    outline: none;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.0);
    margin: 0;
    padding: 0;
  }
  .dotStyle {
    color: #AAD500;
  }
  .ctTableTitleStyle {
    background: #F6F6F6;
    padding: 5px 0;
  }
  @media only screen and (max-width: 768px) {
    .container {
      width: 100vw;
    }
    th, td {
      padding: 0px !important;
      text-align: left;
    }
  }
</style>
